export default function FaqData() {
    return [
        {
            title: "What is term life insurance?",
            text: ["The \"term\" in term insurance refers to the period of time you want to keep continuous coverage without the risk of a premium increase. The policy is paid to the beneficiary you choose if you pass away during the plan’s term."]
        },
        {
            title: "Will my premiums increase during the term of coverage?",
            text: ["Term insurance typically is guaranteed to not increase for the initial term of the policy. In addition, once you are approved your coverage cannot be rescinded, even if your health changes down the road."]
        },
        {
            title: "What are the premium rates based on?",
            text: ["Premiums are based on several different factors, including age, gender, tobacco use, and the term and amount of insurance coverage you choose."]
        },
        {
            title: "When will my coverage begin?",
            text: ["Your coverage becomes effective after your application is approved and the carrier receives your first premium payment. Once your application is approved, you will also receive your policy which will include information confirming the billing method, timing of the first premium due and all subsequent premium payment dates thereafter."]
        },
        {
            title: "Can I extend the length of my policy?",
            text: ["At the end of your policy term, you may choose to renew your policy in one-year increments without undergoing additional underwriting. Premiums will increase annually."]
        },
        {
            title: "What benefit do I receive if I become terminally ill?",
            text: ["If you are diagnosed with a terminal illness with a life expectancy of 12-24 months or less, the Accelerated Death Benefit Rider allows you to receive a significant portion of the death benefit while still alive. This option is automatically included with your policy. There may be a fee to exercise this rider."]
        }]
}